<template>
  <div class="tree-filter-container">
    <FilterCard title="">
      <template #title>
        <h1 class="filter-card-title">{{ title }}</h1>
      </template>
      <ul>
        <Tree
          v-for="category in formattedCategories"
          :key="category.slugUrl"
          :node="category"
          @clicked="onTreeClick"
        />
      </ul>
    </FilterCard>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tree from '@sephora-asia/core-tree/Tree.vue'
import categoryHelper from '../mixins/categoryHelper'
import FilterCard from './FilterCard.vue'

export default {
  name: 'TreeFilterContainer',
  components: {
    FilterCard,
    Tree
  },
  mixins: [categoryHelper],
  props: {
    entityType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeCategory: this._defaultActiveCategory()
    }
  },
  computed: {
    ...mapGetters({
      brand: 'listingPageBrand/brand'
    }),

    formattedCategories() {
      let categories
      let filterFn

      if (this.entityType === 'category') {
        // This is to deep copy the data from state
        const categoriesCopy = JSON.parse(JSON.stringify(this.categories))
        categories = this._transformCategories(categoriesCopy)
        filterFn = this._filterBySlugUrl(this.$route.params.topCategory)
      } else {
        // This is to deep copy the data from state
        categories = JSON.parse(JSON.stringify(this.categoryFilters))
        filterFn = this._filterByParentId(undefined)
      }

      return this.categoryTree(categories, this.categorySlugUrl, filterFn)
    },
    title() {
      switch (this.entityType) {
        case 'brand':
          return this.brand.name
        case 'category':
          return this.activeCategory.label
        case 'search':
          return this.$route.query.q
        default:
          return ''
      }
    }
  },
  methods: {
    onTreeClick(node) {
      this.categorySlugUrl = node.slugUrl
      this.navigateToCategory(node.slugUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-filter-container {
  border-top: 1px solid $grey;

  ::v-deep .filter-card-content {
    max-height: inherit;
  }
}
</style>
